import 'client-only';

export {
  AxiosError as HttpError,
  AxiosHeaders as HttpHeaders,
  type AxiosResponse as HttpResponse,
} from 'axios';
import { buildAxiosInstance } from './builder';

export interface ValidationErrorData<
  T extends object = Record<string, string>,
> {
  message?: string;
  errors: T;
}

// Create wrapper instance with all default options and request/response interceptors.
const clientHttpWrapper = buildAxiosInstance();

export const { get, put, post, patch, delete: httpDelete } = clientHttpWrapper;

/**
 * If you are making an HTTP request in client code, you should use this unless you have a
 * specific reason not to do so.
 *
 * The `httpWrapper` provides modified versions of Axios' request methods (get, post, ect.)
 * that are augmented with interceptors for CSRF token negotiation behavior. The returned
 * Axios instance can be used in all the same ways as a raw Axios instance.
 *
 * ## Example
 * ``` javascript
 *  import { get, post, axiosDelete } from '@/utils/httpWrapper/client'
 *
 *  const getResponse = await get('https://app.curology.com/api/foo')
 *  const postResponse = await post('https://app.curology.com/api/foo', { foo: "bar" })
 *  const deleteResponse = await axiosDelete('https://app.curology.com/api/foo/1')
 * ```
 */
export default clientHttpWrapper;
